import { render, staticRenderFns } from "./PurchaseMark.vue?vue&type=template&id=6a36cde7"
import script from "./PurchaseMark.vue?vue&type=script&lang=js"
export * from "./PurchaseMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports